import { defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import type { Ref } from 'vue';
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import { useStore } from '@/store';
import {
  CREATE_NEW_PROJECT,
  EDIT_PROJECT,
} from '@/store/types/actions';

import ProjectInterface from '@/interfaces/Project.interface';
import DSModal from '@/design-system/DSModal.vue';
import DSTextField from '@/design-system/DSTextField.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEditProjectModal',
  setup(__props, { expose: __expose }) {

const store = useStore();
const $q = useQuasar();

const show_modal = ref(false);
const project: Ref<ProjectInterface> = ref({} as ProjectInterface);
const project_name = ref('');
const request_pending = ref(false);

const handleSubmit = async () => {
  if (!project_name.value) return;

  request_pending.value = true;

  try {
    if (project.value.id) {
      await store.dispatch(EDIT_PROJECT, {
        id: project.value.id,
        name: project_name.value,
      });
    } else {
      await store.dispatch(CREATE_NEW_PROJECT, project_name.value);
    }

    $q.notify({
      progress: true,
      type: 'positive',
      message: 'Your project is available!',
      position: 'top-right',
      icon: 'check_circle',
    });

    project_name.value = '';
    show_modal.value = false;
  } finally {
    request_pending.value = false;
  }
};

const handleCancel = () => {
  project_name.value = '';
  show_modal.value = false;
};

const showModal = (edit_project?: ProjectInterface) => {
  project.value = {} as ProjectInterface;
  project_name.value = '';

  if (edit_project) {
    project.value = edit_project;
    project_name.value = edit_project.name;
  }

  show_modal.value = true;
};

__expose({
  show_modal,
  project,
  showModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DSModal, {
    modelValue: show_modal.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((show_modal).value = $event)),
    title: project.value.id ? 'Edit Project' : 'New Project',
    loading: request_pending.value,
    "confirm-label": project.value.id ? 'Save' : 'Create',
    onConfirm: handleSubmit,
    onCancel: handleCancel
  }, {
    body: _withCtx(() => [
      _createVNode(DSTextField, {
        modelValue: project_name.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((project_name).value = $event)),
        label: "Project Name",
        placeholder: "Enter project name",
        icon: "folder",
        autofocus: "",
        disabled: request_pending.value,
        onKeyup: _withKeys(handleSubmit, ["enter"]),
        "aria-label": "Project name"
      }, null, 8, ["modelValue", "disabled", "onKeyup"])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "loading", "confirm-label"]))
}
}

})